/**
 * Tax – VAT registration & order registration
 */

export default {
  vatReg: {
    country: "Country",
    jurisdiction: "Jurisdiction",
    reasonForReg: "Reason for registration",
    vatNum: "VAT number",
    from: "From",
    till: "Till",
    tablePeriodicity: "Periodicity",
    tableFirstPeriodDue: "First period due",
    status: "Status",
    changeActive: "Change status",
    statusLabelNew: "New",
    statusLabelActive: "Active",
    statusLabelNotActive: "Not active",
    statusLabelDeregistered: "Deregistered",
    active: "Active",
    edit: "Edit",
    thresh: "Threshold",
    vatRepr: "VAT representative",
    actions: "Actions",
    continue: "Continue",
    pay: "Pay",
    addVatReg: "Add a VAT",
    orderVatReg: "Order a VAT",
    enterVatNum: "Please enter VAT number",
    enterStNum: "Please enter Steuernummer",
    invalidVal: "Invalid value",
    editVatReg: "Edit VAT registration number",
    for: "for",
    in: "in",
    federalSt: "Federal state",
    stNum: "Steuernummer",
    numberValidTill: "Number valid till",
    lovatTaxRep: "Lappa is my tax representative",
    calcThresh: {
      yes: "calculate threshold",
      no: "don`t calculate threshold",
    },
    vatRegPayment: "VAT registration payment",
    vatReg: "VAT registration",
    payment: "Payment",
    thankForReq:
      "Thank you for your request! You will be emailed with the invoice and further instructions within several hours.",
    validFrom: "Valid from",
    validTill: "Valid till",
    appLovat: "I'd like to appoint Lappa as my tax representative",
    taxRepThroughLovat:
      "The number will be not used for tax reporting through Lappa",
    contactManager1: "Please, contact your personal manager",
    contactManager2: ", if you want to delete VAT number",
    vatRegOf: "Vat registration of",
    vatRegIn1: "VAT registration in",
    vatRegIn2: ", ",
    vatRegIn3: "",
    addRegInfo: "Add registration info",
    cancel: "Cancel",
    delete: "Delete",
    delVatREg: "Delete VAT registration order",
    wantDelFor:
      "Do you want to delete this not finished registration request for",
    err: "Error",
    yes: "Yes",
    no: "No",
    notFinished: "Not finished",
    calcThresholds: "Calculate distance sales thresholds for all countries",
    chooseFile: "Choose file",
    province: "Province",
    tin: "TIN number",
  },
  orderReg: {
    pageSubtitle: "Here you can order a VAT number",
    country: "Country",
    reasonForReg: "Reason for registration",
    lovatMyTaxRepr: "I want Lappa to be my tax representative",
    steps: {
      intro: "Introduction",
      persInfo: "Personal information",
      business: "Business details",
      docs: "Documents",
      submit: "Submit",
    },
    discard: "Discard",
    next: "Next",
    back: "Back",
    vatReg: "VAT registration",
    orderVatReg: "Order VAT registration",
    vatRegIn1: "VAT registration in",
    vatRegIn2: "",
    vatRegIn1p: "VAT registration in",
    vatRegIn2p: ", ",
    vatRegIn3p: "",
    haveNotFinished: "You have not finnished registration request",
    createNewReq: "Create new request",
    cont: "Continue",
    wantCont: "Do you want to continue?",
    yourName: "Your name",
    prevName: "Previuos name",
    changeName: "Did you change the name? If yes - previuos name",
    dateOfBirth: "Date of birth",
    origCountry: "Country of origin",
    contacts: "Contacts",
    persAddress: "Personal address",
    postPersAddress: "Postcode and personal address (last 3 years)",
    yourEmail: "Your e-mail",
    phoneNum: "Phone number",
    ifAppl: "If applicable",
    nin: "National Insurance Number",
    utr: "Unique Taxpayer Reference",
    bussInfo: "Business information",
    crn: "Company Registration Number (CRN)",
    dateOfInc: "Date of incorporation",
    nameOfCorp: "Name of corporate body",
    compContacts: "Company contacts",
    compEmail: "Company e-mail",
    compPhoneNum: "Company phone number",
    compAddress: "Company address",
    orderPlaced: "Your order has been placed.",
    invWillBeSent: "The invoice for payment will be sent to your email soon.",
    await5wd: "We are awaiting for the payment within 5 working days.",
    uploadFiles: "Upload files",
    vatRegPayment: "VAT registration payment",
    payment: "Payment",
    thankForReq:
      "Thank you for your request! You will be emailed with the invoice and further instructions within several hours.",
    stepDocs: {
      attachDocs: "Please attach the following documents for the director",
      whichCopy:
        "One piece of government issued photographic identification, which can be a copy of:",
      passport: "passport",
      photo: "photocard driving licence",
      idCard: "national identity card",
      attachFiles: "Attach files:",
      secEvid:
        "Along with two pieces of secondary evidence which can be copies of:",
      mortState: "a mortgage statement",
      agree: "a lease/rental agreement",
      birthCertif: "a birth certificate",
      partCertif: "a marriage or civil partnership certificate",
      dissCertif: "a decree absolute of decree of dissolution certificate",
      attachFirst: "Attach the first piece files:",
      attachSecond: "Attach the second piece files:",
    },
    countryWantReg: "Country where you want to get registered",
    que: "Question",
    answ: "Answer",
    submitInfo: "Submit information",
    yes: "Yes",
    no: "No",
  },
};
